<template>
  <component
    :is="href ? 'a' : 'div'"
    v-bind="$attrs"
    data-qa-base="info_card"
    class="info-card rounded-20 d-flex flex-column justify-center bg-gray-0 pa-sm-5 pa-4"
    :class="{ 'info-card--hover': useHover }"
    :href="href"
    v-on="$listeners"
  >
    <div class="d-flex align-center gc-4">
      <span
        class="info-card__icon bg-lpu-branding-color-primary"
        :class="[
          icon,
          { 'ui-icon-fz-medium info-card__icon--mobile': isMobile },
        ]"
      />
      <div class="d-flex flex-column gr-2">
        <div
          v-if="title"
          data-qa="info_card_title"
          class="text-body-1 text-secondary--text"
        >
          {{ title }}
        </div>
        <div
          v-if="subtitle || $slots.subtitle"
          class="d-flex align-center gc-2"
        >
          <div
            data-qa="info_card_subtitle"
            class="text-subtitle-1 text--text"
          >
            <slot name="subtitle">
              {{ subtitle }}
            </slot>
          </div>
          <slot name="subtitle-append-icon" />
        </div>
      </div>

      <div
        v-if="isMobile"
        class="ui-icon-arrow-right icon-secondary--text ml-auto"
      />
    </div>

    <slot name="extra-content" />
  </component>
</template>

<script lang="ts">
import useIsMobile from 'src/composables/useIsMobile'

export default {
  inheritAttrs: false,
}
</script>

<script lang="ts" setup>
defineProps<{
  useHover?: boolean
  icon: string
  title?: string
  subtitle?: string
  href?: string
}>()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.info-card {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  box-shadow: 0 2px 24px 0 rgba(9, 42, 72, 0.08), 0 0 2px 0 rgba(21, 40, 92, 0.06), 0 1px 2px 0 rgba(5, 23, 40, 0.08);
  transition: border-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  &--hover:hover {
    border-color: var(--lpu-branding-color-primary, transparent);
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $border-radius-circle;
    color: $ui-kit-bg-gray-0;
    flex-shrink: 0;
    height: 40px;
    width: 40px;
    text-align: center;

    &--mobile {
      align-self: start;
      height: 32px;
      width: 32px;
    }
  }
}
</style>
